import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/pictos/GreenStickpin.png'
import _imports_1 from '../../../assets/pictos/RedStickpin.png'
import _imports_2 from './assets/reverse.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-45beff10")

_pushScopeId("data-v-45beff10")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "head" }, [
  /*#__PURE__*/_createVNode("span", { class: "title" }, "Route Planning")
], -1)
const _hoisted_2 = { class: "tab-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Route")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Data")
const _hoisted_6 = { class: "route-search" }
const _hoisted_7 = { class: "adresses-container" }
const _hoisted_8 = { class: "left-part" }
const _hoisted_9 = { class: "firstInput" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "stick"
}, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "geocode-suggestions"
}
const _hoisted_12 = {
  key: 0,
  class: "address-loader for-address"
}
const _hoisted_13 = { class: "separator select-from" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Event Location(s) ")
const _hoisted_15 = {
  key: 0,
  class: "address-loader"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  style: {"margin-left":"5%"}
}
const _hoisted_18 = {
  key: 0,
  style: {"color":"black"},
  class: "esri-icon esri-icon-locate"
}
const _hoisted_19 = {
  key: 1,
  style: {"color":"springgreen"},
  class: "esri-icon esri-icon-locate"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "blank-separator" }, null, -1)
const _hoisted_21 = { class: "secondInput" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "stick"
}, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "geocode-suggestions"
}
const _hoisted_24 = {
  key: 0,
  class: "address-loader for-address"
}
const _hoisted_25 = { class: "separator" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Event Location(s) ")
const _hoisted_27 = {
  key: 0,
  class: "address-loader"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  style: {"color":"black"},
  class: "esri-icon esri-icon-locate"
}
const _hoisted_31 = {
  key: 1,
  style: {"color":"red"},
  class: "esri-icon esri-icon-locate"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_33 = { style: {"margin-top":"10px"} }
const _hoisted_34 = { class: "steps" }
const _hoisted_35 = {
  class: "via-in-list",
  slot: "actions-start"
}
const _hoisted_36 = {
  key: 0,
  class: "via-name"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "via-lat" }
const _hoisted_39 = { class: "via-lng" }
const _hoisted_40 = { class: "step-and-save" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { style: {"color":"black"} }, [
  /*#__PURE__*/_createVNode("b", null, "Add")
], -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Save predefined routes", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { slot: "content" }, [
  /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
    /*#__PURE__*/_createVNode("span", null, "Operational service levels"),
    /*#__PURE__*/_createVNode("select", {
      style: {"margin-top":"15px"},
      id: "oslPredefinedMultiselect"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
    /*#__PURE__*/_createVNode("span", null, "Clients"),
    /*#__PURE__*/_createVNode("select", {
      style: {"margin-top":"15px"},
      id: "clientsPredefinedMultiselect"
    })
  ])
], -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Cancel ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Save ")
const _hoisted_46 = { style: {"margin-top":"10px"} }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", null, "Vehicle types", -1)
const _hoisted_48 = {
  id: "vehicleMultiselect",
  ref: "vehicleMultiselect"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createVNode("span", null, "Day labels"),
  /*#__PURE__*/_createVNode("select", { id: "dayMultiselect" })
], -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createVNode("span", null, "Operational service levels"),
  /*#__PURE__*/_createVNode("select", { id: "oslMultiselect" })
], -1)
const _hoisted_51 = { style: {"margin-top":"10px"} }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createVNode("span", null, "Overlays"),
  /*#__PURE__*/_createVNode("select", { id: "multiselect" })
], -1)
const _hoisted_55 = { class: "dateTime" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Hours not specified")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Leave now")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Depart at")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Arrive by")
const _hoisted_60 = {
  ref: "dateTimePicker",
  id: "dateTimePicker"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("input", { id: "dateTimePicker2" }, null, -1)
const _hoisted_62 = { class: "transport" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", null, "Mode ", -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Car")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Taxi")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Bus")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Truck")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Bike")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Pedestrian")
const _hoisted_70 = { style: {"margin-top":"10px"} }
const _hoisted_71 = { class: "routerOptions" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Traffic ", -1)
const _hoisted_73 = { class: "col-30" }
const _hoisted_74 = { class: "routerOptions" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Traverse gates ", -1)
const _hoisted_76 = { class: "col-30" }
const _hoisted_77 = { class: "routerOptions" }
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Use precomputed route ", -1)
const _hoisted_79 = { class: "col-30" }
const _hoisted_80 = { class: "routerOptions" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", {
  class: "col-50",
  title: "Enabled: Returns the travel time for the free, average, and pessemistics traffic conditions for the selected the departure (or arrival) day and time.\r\rThis option is not applicable if the routing version is disabled or if the precomputed route option is enabled.\r\rNote, this routing service returns the free and average travel times if the infer travel time service has not be set up for the event region."
}, " Infer travel time ", -1)
const _hoisted_82 = { class: "col-30" }
const _hoisted_83 = { class: "routerOptions" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Routing version ", -1)
const _hoisted_85 = { class: "col-30" }
const _hoisted_86 = { class: "routerOptions" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Honor checkpoint ", -1)
const _hoisted_88 = { class: "col-30" }
const _hoisted_89 = { class: "routerOptions" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Honor steps ", -1)
const _hoisted_91 = { class: "col-30" }
const _hoisted_92 = { class: "routerOptions" }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "col-50" }, " Direction units ", -1)
const _hoisted_94 = { class: "col-30" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("KM ")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("MI ")
const _hoisted_97 = { class: "radius hidden" }
const _hoisted_98 = { class: "button" }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { class: "esri-icon-duplicate" }, null, -1)
const _hoisted_100 = {
  key: 0,
  class: "error"
}
const _hoisted_101 = {
  key: 1,
  class: "results"
}
const _hoisted_102 = { class: "time" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode("Travel time: ")
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "distance" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("Distance: ")
const _hoisted_109 = { key: 1 }
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Distance: ")
const _hoisted_111 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_113 = {
  key: 0,
  class: "depart"
}
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Departure: ")
const _hoisted_116 = {
  key: 1,
  class: "arrive"
}
const _hoisted_117 = { key: 0 }
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Arrival: ")
const _hoisted_119 = {
  "icon-position": "end",
  "icon-type": "chevron"
}
const _hoisted_120 = { class: "maneuver" }
const _hoisted_121 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("img", {
    width: "24",
    src: _imports_0
  })
], -1)
const _hoisted_122 = {
  key: 10,
  width: "24",
  src: _imports_1
}
const _hoisted_123 = { class: "import-container" }
const _hoisted_124 = /*#__PURE__*/_createVNode("div", { class: "text-help" }, " 1. Export the calculated route in a geojson file. ", -1)
const _hoisted_125 = { class: "export-container" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Start, end and vias")
const _hoisted_127 = /*#__PURE__*/_createTextVNode("Route")
const _hoisted_128 = { class: "btn-container" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Export ")
const _hoisted_130 = { class: "import-block" }
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "text-help" }, " 2. Import a predefined route from a point collection or route layer. ", -1)
const _hoisted_132 = { class: "btn-container" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode("Import ")
const _hoisted_134 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Import Predefined Route", -1)
const _hoisted_135 = { slot: "content" }
const _hoisted_136 = {
  key: 0,
  style: {"text-align":"start"}
}
const _hoisted_137 = { key: 0 }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" type Polyline ")
const _hoisted_139 = { key: 0 }
const _hoisted_140 = { key: 1 }
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" type Point ")
const _hoisted_142 = { key: 0 }
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { class: "warnings" }
const _hoisted_145 = /*#__PURE__*/_createVNode("span", null, "Ignore warnings during import ", -1)
const _hoisted_146 = { class: "warningsSwitch" }
const _hoisted_147 = /*#__PURE__*/_createVNode("span", { class: "label-version" }, "Off", -1)
const _hoisted_148 = /*#__PURE__*/_createVNode("span", { class: "label-version" }, "On", -1)
const _hoisted_149 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_151 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_152 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Warning", -1)
const _hoisted_153 = {
  slot: "content",
  class: "content"
}
const _hoisted_154 = /*#__PURE__*/_createTextVNode("Ok ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_tab_title = _resolveComponent("calcite-tab-title")
  const _component_calcite_tab_nav = _resolveComponent("calcite-tab-nav")
  const _component_calcite_action = _resolveComponent("calcite-action")
  const _component_calcite_value_list_item = _resolveComponent("calcite-value-list-item")
  const _component_calcite_value_list = _resolveComponent("calcite-value-list")
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_modal = _resolveComponent("calcite-modal")
  const _component_calcite_accordion_item = _resolveComponent("calcite-accordion-item")
  const _component_calcite_accordion = _resolveComponent("calcite-accordion")
  const _component_calcite_option = _resolveComponent("calcite-option")
  const _component_calcite_select = _resolveComponent("calcite-select")
  const _component_calcite_switch = _resolveComponent("calcite-switch")
  const _component_calcite_input = _resolveComponent("calcite-input")
  const _component_calcite_tab = _resolveComponent("calcite-tab")
  const _component_calcite_icon = _resolveComponent("calcite-icon")
  const _component_calcite_tabs = _resolveComponent("calcite-tabs")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: ["esri-widget route-container", {'containerWidth': _ctx.showReverse}]
    }, [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_calcite_tabs, {
          ref: "tabs",
          layout: "center",
          position: "above",
          scale: "m"
        }, {
          default: _withId(() => [
            _createVNode(_component_calcite_tab_nav, { slot: "tab-nav" }, {
              default: _withId(() => [
                _createVNode(_component_calcite_tab_title, { active: "" }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_calcite_tab_title, {
                  disabled: !_ctx.isResultTabVisible,
                  class: "tab-Route"
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_calcite_tab_title, null, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_tab, { active: "" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "address-bar",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.adressFrom = $event)),
                          onInput: _cache[2] || (_cache[2] = $event => (_ctx.addressChange($event, "from"))),
                          onFocus: _cache[3] || (_cache[3] = $event => (_ctx.changeFocusInputFrom($event, 'from'))),
                          onBlur: _cache[4] || (_cache[4] = $event => (_ctx.changeFocusInputFrom($event, 'from')))
                        }, null, 544), [
                          [_vModelText, _ctx.adressFrom]
                        ]),
                        (_ctx.geocodeFrom.length > 0 || _ctx.poisFrom.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              (_ctx.geocodeIsLoading)
                                ? (_openBlock(), _createBlock("div", _hoisted_12))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.geocodeFrom, (geocode) => {
                                return (_openBlock(), _createBlock("option", {
                                  tabindex: "0",
                                  class: "select-geocode select-from",
                                  onClick: $event => (_ctx.populateFrom(geocode))
                                }, _toDisplayString(geocode.title), 9, ["onClick"]))
                              }), 256)),
                              _createVNode("div", _hoisted_13, [
                                _hoisted_14,
                                (_ctx.poisIsLoading)
                                  ? (_openBlock(), _createBlock("span", _hoisted_15))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.poisFrom, (pois) => {
                                return (_openBlock(), _createBlock("div", null, [
                                  _createVNode("option", {
                                    tabindex: "0",
                                    class: "select-geocode select-from",
                                    onClick: $event => (_ctx.populateWithPoiFrom(pois))
                                  }, [
                                    pois
                                      ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(pois.properties.Name) + " - " + _toDisplayString(pois.properties.Address), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, ["onClick"]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(pois.properties.TransportationPoint, (subPois) => {
                                    return (_openBlock(), _createBlock("option", {
                                      tabindex: "0",
                                      class: "select-geocode select-from sub-pois",
                                      onClick: $event => (_ctx.populateWithPoiFrom(subPois, pois))
                                    }, [
                                      subPois
                                        ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(subPois.properties.Name) + " - " + _toDisplayString(subPois.properties.Address), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, ["onClick"]))
                                  }), 256))
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          class: "clean",
                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.erase('from'))),
                          title: "Erase"
                        }, "✕"),
                        _createVNode("button", {
                          class: "pin",
                          onClick: _cache[6] || (_cache[6] = $event => (_ctx.pin('start'))),
                          title: "Place a marker to the map as departure point"
                        }, [
                          (!_ctx.greenPinIsClickable)
                            ? (_openBlock(), _createBlock("span", _hoisted_18))
                            : _createCommentVNode("", true),
                          (_ctx.greenPinIsClickable)
                            ? (_openBlock(), _createBlock("span", _hoisted_19))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", {
                        class: ["coordinates", { hidden: !_ctx.coordsFrom.lat || !_ctx.coordsFrom.lng }]
                      }, [
                        _createVNode("span", null, "Lat : " + _toDisplayString(_ctx.coordsFrom.lat) + ", Lng : " + _toDisplayString(_ctx.coordsFrom.lng), 1)
                      ], 2),
                      _hoisted_20,
                      _createVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "address-bar",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.adressTo = $event)),
                          onInput: _cache[8] || (_cache[8] = $event => (_ctx.addressChange($event, "to"))),
                          onFocus: _cache[9] || (_cache[9] = $event => (_ctx.changeFocusInputFrom($event, 'to'))),
                          onBlur: _cache[10] || (_cache[10] = $event => (_ctx.changeFocusInputFrom($event, 'to')))
                        }, null, 544), [
                          [_vModelText, _ctx.adressTo]
                        ]),
                        (_ctx.geocodeTo.length > 0 || _ctx.poisTo.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_23, [
                              (_ctx.geocodeIsLoading)
                                ? (_openBlock(), _createBlock("span", _hoisted_24))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.geocodeTo, (geocode) => {
                                return (_openBlock(), _createBlock("option", {
                                  tabindex: " 0",
                                  class: "select-geocode select-to",
                                  onClick: $event => (_ctx.populateTo(geocode))
                                }, _toDisplayString(geocode.title), 9, ["onClick"]))
                              }), 256)),
                              _createVNode("div", _hoisted_25, [
                                _hoisted_26,
                                (_ctx.poisIsLoading)
                                  ? (_openBlock(), _createBlock("span", _hoisted_27))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.poisTo, (pois) => {
                                return (_openBlock(), _createBlock("div", null, [
                                  _createVNode("option", {
                                    tabindex: "0",
                                    class: "select-geocode select-to",
                                    onClick: $event => (_ctx.populateWithPoiTo(pois))
                                  }, [
                                    pois
                                      ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(pois.properties.Name) + " - " + _toDisplayString(pois.properties.Address), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, ["onClick"]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(pois.properties.TransportationPoint, (subPois) => {
                                    return (_openBlock(), _createBlock("option", {
                                      tabindex: "0",
                                      class: "select-geocode select-to sub-pois",
                                      onClick: $event => (_ctx.populateWithPoiTo(subPois, pois))
                                    }, [
                                      subPois
                                        ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(subPois.properties.Name) + " - " + _toDisplayString(subPois.properties.Address), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, ["onClick"]))
                                  }), 256))
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          class: "clean",
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.erase('to'))),
                          title: "Erase"
                        }, "✕"),
                        _createVNode("button", {
                          class: "pin",
                          onClick: _cache[12] || (_cache[12] = $event => (_ctx.pin('end'))),
                          title: "Place a marker to the map as arrival point"
                        }, [
                          (!_ctx.redPinIsClickable)
                            ? (_openBlock(), _createBlock("span", _hoisted_30))
                            : _createCommentVNode("", true),
                          (_ctx.redPinIsClickable)
                            ? (_openBlock(), _createBlock("span", _hoisted_31))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", {
                        class: ["coordinates", { hidden: !_ctx.coordsTo.lat || !_ctx.coordsTo.lng }]
                      }, [
                        _createVNode("span", null, "Lat : " + _toDisplayString(_ctx.coordsTo.lat) + ", Lng : " + _toDisplayString(_ctx.coordsTo.lng), 1)
                      ], 2)
                    ]),
                    _createVNode("div", {
                      class: [{'reverse': !_ctx.isCoordinatesFrom}, "right-part"]
                    }, [
                      _createVNode("button", {
                        class: {'btn-disabled': !_ctx.showReverse},
                        disabled: !_ctx.showReverse,
                        onClick: _cache[13] || (_cache[13] = $event => (_ctx.reverse()))
                      }, [
                        _hoisted_32
                      ], 10, ["disabled"])
                    ], 2)
                  ]),
                  _createVNode(_component_calcite_accordion, {
                    "icon-position": "end",
                    "icon-type": "chevron",
                    style: {"margin-top":"15px"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_calcite_accordion_item, { "item-title": "Steps" }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_33, [
                            _createVNode("div", _hoisted_34, [
                              _createVNode(_component_calcite_value_list, {
                                class: "point",
                                ref: "allSteps",
                                onDrop: _cache[14] || (_cache[14] = $event => (_ctx.viaDrop())),
                                "label-editing-enabled": ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viaPointsHtml, (via, index) => {
                                    return (_openBlock(), _createBlock(_component_calcite_value_list_item, { value: via }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_35, [
                                          _createVNode("div", {
                                            class: "via-color",
                                            style: 'background-color:' + via.color + ';'
                                          }, _toDisplayString(index+1), 5),
                                          (via.name != null)
                                            ? (_openBlock(), _createBlock("div", _hoisted_36, _toDisplayString(via.name), 1))
                                            : (_openBlock(), _createBlock("div", _hoisted_37, [
                                                _createVNode("span", _hoisted_38, "Lat: " + _toDisplayString(_ctx.getCoordRounded(via.lat)), 1),
                                                _createVNode("span", _hoisted_39, "Lng: " + _toDisplayString(_ctx.getCoordRounded(via.lng)), 1)
                                              ]))
                                        ]),
                                        _createVNode(_component_calcite_action, {
                                          class: "delete",
                                          slot: "actions-end",
                                          onClick: $event => (_ctx.removeViaPoint(via)),
                                          icon: "x"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 512),
                              _createVNode("div", _hoisted_40, [
                                _createVNode(_component_calcite_button, {
                                  onClick: _cache[15] || (_cache[15] = $event => (_ctx.startAddingStep())),
                                  class: ["btn-add-step", _ctx.addVia == true? 'add-via':''],
                                  color: "neutral",
                                  "icon-flip-rtl": "both",
                                  "icon-start": "circle-area",
                                  round: "",
                                  scale: "s",
                                  "split-child": "primary",
                                  disabled: !_ctx.listIsValid
                                }, {
                                  default: _withId(() => [
                                    _hoisted_41
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "class"]),
                                _createVNode(_component_calcite_button, {
                                  ref: "deleteAllPin",
                                  onClick: _cache[16] || (_cache[16] = $event => (_ctx.deleteAllPoints())),
                                  disabled: !(_ctx.viaPointsHtml.length > 1),
                                  class: "btn-add-step right-side-via-button",
                                  color: "blue",
                                  scale: "s",
                                  l: "",
                                  "icon-end": "trash",
                                  title: "Delete all steps"
                                }, null, 8, ["disabled"]),
                                (_ctx.locationPointFrom != '' && _ctx.locationPointTo != '' && _ctx.canSave == true)
                                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                                      key: 0,
                                      ref: "saveMatrix",
                                      onClick: _cache[17] || (_cache[17] = $event => (_ctx.showPredefinedModal())),
                                      class: "btn-add-step",
                                      color: "blue",
                                      scale: "s",
                                      "icon-end": "save"
                                    }, null, 512))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_calcite_modal, {
                                  width: "s",
                                  active: "false",
                                  "disable-close-button": "",
                                  "disable-outside-close": "",
                                  ref: "predefinedModal"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_42,
                                    _hoisted_43,
                                    _createVNode(_component_calcite_button, {
                                      slot: "back",
                                      color: "light",
                                      onClick: _cache[18] || (_cache[18] = $event => {_ctx.hidePredefinedModal(); _ctx.size = 0})
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_44
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_calcite_button, {
                                      slot: "primary",
                                      color: "blue",
                                      onClick: _cache[19] || (_cache[19] = $event => {_ctx.saveMatrix(); _ctx.hidePredefinedModal();})
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_45
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_calcite_accordion, {
                    "icon-position": "end",
                    "icon-type": "chevron",
                    style: {"margin-top":"15px"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_calcite_accordion_item, { "item-title": "Overlays" }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", null, [
                              _hoisted_47,
                              _createVNode("select", _hoisted_48, null, 512)
                            ]),
                            _hoisted_49,
                            _hoisted_50,
                            _createVNode("div", _hoisted_51, [
                              _createVNode(_component_calcite_button, {
                                appearance: "solid",
                                scale: "s",
                                onClick: _cache[20] || (_cache[20] = $event => {_ctx.updateOverlaysList();})
                              }, {
                                default: _withId(() => [
                                  _hoisted_52
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_calcite_button, {
                                appearance: "solid",
                                scale: "s",
                                onClick: _cache[21] || (_cache[21] = $event => {_ctx.resetOverlaysList();}),
                                style: {"margin-left":"5px"}
                              }, {
                                default: _withId(() => [
                                  _hoisted_53
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _hoisted_54
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_55, [
                    _createVNode(_component_calcite_select, { ref: "hourSelect" }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_option, { value: "noHours" }, {
                          default: _withId(() => [
                            _hoisted_56
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, {
                          value: "now",
                          selected: ""
                        }, {
                          default: _withId(() => [
                            _hoisted_57
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "depAt" }, {
                          default: _withId(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "arrAt" }, {
                          default: _withId(() => [
                            _hoisted_59
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _createVNode("div", {
                    class: ["departure", {'hidden': _ctx.isDepartureHidden}]
                  }, [
                    _createVNode("input", _hoisted_60, null, 512)
                  ], 2),
                  _createVNode("div", {
                    class: ["arrival", {'hidden': _ctx.isArrivalHidden}]
                  }, [
                    _hoisted_61
                  ], 2),
                  _createVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createVNode(_component_calcite_select, { style: {"margin-left":"10px","width":"100%"} }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_option, { value: "car" }, {
                          default: _withId(() => [
                            _hoisted_64
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "taxi" }, {
                          default: _withId(() => [
                            _hoisted_65
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "bus" }, {
                          default: _withId(() => [
                            _hoisted_66
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "truck" }, {
                          default: _withId(() => [
                            _hoisted_67
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "bicycle" }, {
                          default: _withId(() => [
                            _hoisted_68
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_calcite_option, { value: "pedestrian" }, {
                          default: _withId(() => [
                            _hoisted_69
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_calcite_accordion, {
                    "icon-position": "end",
                    "icon-type": "chevron",
                    style: {"margin-top":"15px"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_calcite_accordion_item, { "item-title": "Options" }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_70, [
                            _createVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createVNode("div", _hoisted_73, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "useTraffic",
                                  name: "switchTraffic",
                                  scale: "m",
                                  switched: "",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Latest traffic information is used for computing the best route.\r\rDisabled: Computes the route with historical traffic pattern."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode("div", _hoisted_76, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "traverseGate",
                                  name: "switchTraverseGate",
                                  scale: "m",
                                  switched: "",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Allows to traverse private gates.\r\rDisabled: Avoid them."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_77, [
                              _hoisted_78,
                              _createVNode("div", _hoisted_79, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "usePrecomputedRoute",
                                  name: "switchUsePrecomputedRoute",
                                  switched: "",
                                  scale: "m",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Returns the precomputed route if the start and end of the route and the selected the departure (or arrival) time match an existing route computed with Origin-Destination Matrix wigdet."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_80, [
                              _hoisted_81,
                              _createVNode("div", _hoisted_82, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "useTravelTimeService",
                                  name: "switchInferTravelTime",
                                  scale: "m",
                                  disabled: "",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Returns the travel time for the free, average, and pessemistics traffic conditions for the selected the departure (or arrival) day and time.\r\rThis option is not applicable if the routing version is disabled or if the precomputed route option is enabled.\r\rNote, this routing service returns the free and average travel times if the infer travel time service has not be set up for the event region."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_83, [
                              _hoisted_84,
                              _createVNode("div", _hoisted_85, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "routerVersionV8",
                                  name: "switchRouterVersionV8",
                                  switched: "",
                                  scale: "m",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: The lastest v8 routing engine is used to find the best route (recommended option).\r\rDisabled: The previous v7 version is used."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_86, [
                              _hoisted_87,
                              _createVNode("div", _hoisted_88, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "useCheckPoint",
                                  name: "switchUseCheckPoint",
                                  switched: "",
                                  scale: "m",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Force to pass through a vehicle checkpoint if linked to a transportation point set as destination.\r\rDisabled: Ignored."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_89, [
                              _hoisted_90,
                              _createVNode("div", _hoisted_91, [
                                _createVNode(_component_calcite_switch, {
                                  ref: "useSteps",
                                  name: "switchUseSteps",
                                  switched: "",
                                  scale: "m",
                                  style: {"margin-left":"10px"},
                                  title: "Enabled: Force to pass through the steps.\r\rDisabled: Ignored."
                                }, null, 512)
                              ])
                            ]),
                            _createVNode("div", _hoisted_92, [
                              _hoisted_93,
                              _createVNode("div", _hoisted_94, [
                                _createVNode(_component_calcite_button, {
                                  appearance: "solid",
                                  scale: "s",
                                  onClick: _cache[22] || (_cache[22] = $event => {_ctx.unite = 'km'; _ctx.isKm = true; _ctx.isMi = false}),
                                  class: {'blue': !_ctx.isKm, 'darkblue': _ctx.isKm},
                                  style: {"margin-left":"10px"}
                                }, {
                                  default: _withId(() => [
                                    _hoisted_95
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_calcite_button, {
                                  appearance: "solid",
                                  scale: "s",
                                  onClick: _cache[23] || (_cache[23] = $event => {_ctx.unite = 'mi'; _ctx.isMi = true; _ctx.isKm = false}),
                                  class: {'blue': !_ctx.isMi, 'darkblue': _ctx.isMi},
                                  Title: "Units used to displayed the distance in the route result tab."
                                }, {
                                  default: _withId(() => [
                                    _hoisted_96
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_97, [
                    _createVNode("span", {
                      class: {'radiusSpan': _ctx.showReverse}
                    }, "Search radius (m)", 2),
                    _createVNode(_component_calcite_input, {
                      scale: "s",
                      value: "1600",
                      ref: "radiusInput"
                    }, null, 512)
                  ]),
                  _createVNode("div", _hoisted_98, [
                    _createVNode("button", {
                      class: "route",
                      onClick: _cache[24] || (_cache[24] = $event => {_ctx.routeSub(), _ctx.isResultTabVisible = true;}),
                      disabled: _ctx.adressFrom === '' || _ctx.adressTo === '' || !_ctx.isClickable
                    }, "Route", 8, ["disabled"]),
                    (_ctx.isClickable == true)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "delete",
                          onClick: _cache[25] || (_cache[25] = $event => (_ctx.clear()))
                        }, "Clear"))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      title: "Copy",
                      onClick: _cache[26] || (_cache[26] = $event => (_ctx.copy(_ctx.allRoutePlanningDataInClipBoard()))),
                      class: "copyJson"
                    }, [
                      _hoisted_99
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_tab, null, {
              default: _withId(() => [
                (_ctx.isError == true)
                  ? (_openBlock(), _createBlock("div", _hoisted_100, [
                      _createVNode("span", null, _toDisplayString(_ctx.error), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.time2 != '00')
                  ? (_openBlock(), _createBlock("div", _hoisted_101, [
                      _createVNode("div", _hoisted_102, [
                        _createVNode("span", null, [
                          _hoisted_103,
                          _createVNode("b", null, _toDisplayString(_ctx.getHoursMinutes(_ctx.route.data.time)), 1)
                        ]),
                        (_ctx.route.data.baseDuration != null && _ctx.route.data.maxDuration != null && _ctx.route.data.baseDuration != -1 && _ctx.route.data.maxDuration == -1)
                          ? (_openBlock(), _createBlock("span", _hoisted_104, " (Free traffic: " + _toDisplayString(_ctx.getHoursMinutes(_ctx.route.data.baseDuration)) + ")", 1))
                          : _createCommentVNode("", true),
                        (_ctx.route.data.baseDuration != null && _ctx.route.data.maxDuration != null && _ctx.route.data.baseDuration != -1 && _ctx.route.data.maxDuration != -1)
                          ? (_openBlock(), _createBlock("span", _hoisted_105, " (Free traffic: " + _toDisplayString(_ctx.getHoursMinutes(_ctx.route.data.baseDuration)) + " - Max:" + _toDisplayString(_ctx.getHoursMinutes(_ctx.route.data.maxDuration)) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_106, [
                        (_ctx.unite == 'km')
                          ? (_openBlock(), _createBlock("span", _hoisted_107, [
                              _hoisted_108,
                              _createVNode("b", null, _toDisplayString(_ctx.distance) + " km", 1)
                            ]))
                          : (_openBlock(), _createBlock("span", _hoisted_109, [
                              _hoisted_110,
                              _createVNode("b", null, _toDisplayString(_ctx.distance2) + " mi", 1)
                            ])),
                        _hoisted_111,
                        _hoisted_112
                      ]),
                      (_ctx.departure != '' && _ctx.arrival != '')
                        ? (_openBlock(), _createBlock("div", _hoisted_113, [
                            (_ctx.departure)
                              ? (_openBlock(), _createBlock("span", _hoisted_114, [
                                  _hoisted_115,
                                  _createVNode("b", null, _toDisplayString(_ctx.departure), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.arrival != '')
                        ? (_openBlock(), _createBlock("div", _hoisted_116, [
                            (_ctx.arrival)
                              ? (_openBlock(), _createBlock("span", _hoisted_117, [
                                  _hoisted_118,
                                  _createVNode("b", null, _toDisplayString(_ctx.arrival), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.maneuvers)
                  ? (_openBlock(), _createBlock(_component_calcite_accordion, {
                      key: 2,
                      "icon-position": "end",
                      "icon-type": "chevron",
                      class: "maneuversAccordion"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_accordion_item, { "item-title": "Maneuvers" }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_119, [
                              _createVNode("div", _hoisted_120, [
                                _createVNode("table", null, [
                                  _createVNode("tr", null, [
                                    _hoisted_121,
                                    _createVNode("td", null, "Start from " + _toDisplayString(_ctx.adressFrom), 1)
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.maneuvers, (maneuver, index) => {
                                    return (_openBlock(), _createBlock("tr", null, [
                                      _createVNode("td", null, [
                                        (maneuver.direction == 'North')
                                          ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                              key: 0,
                                              icon: "arrow-up"
                                            }))
                                          : (maneuver.direction == 'South')
                                            ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                key: 1,
                                                icon: "arrow-down"
                                              }))
                                            : (maneuver.direction == 'East')
                                              ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                  key: 2,
                                                  icon: "arrow-right"
                                                }))
                                              : (maneuver.direction == 'West')
                                                ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                    key: 3,
                                                    icon: "arrow-left"
                                                  }))
                                                : (maneuver.direction == 'Turn right')
                                                  ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                      key: 4,
                                                      icon: "right"
                                                    }))
                                                  : (maneuver.direction == 'Keep right')
                                                    ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                        key: 5,
                                                        icon: "exit-highway-right"
                                                      }))
                                                    : (maneuver.direction == 'Turn left')
                                                      ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                          key: 6,
                                                          icon: "left"
                                                        }))
                                                      : (maneuver.direction == 'Keep left')
                                                        ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                            key: 7,
                                                            icon: "exit-highway-left"
                                                          }))
                                                        : (maneuver.direction == 'U-Turn')
                                                          ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                              key: 8,
                                                              icon: "u-turn"
                                                            }))
                                                          : (maneuver.direction == 'exit from roundabout')
                                                            ? (_openBlock(), _createBlock(_component_calcite_icon, {
                                                                key: 9,
                                                                icon: "round-about"
                                                              }))
                                                            : (index == _ctx.maneuvers.length-1)
                                                              ? (_openBlock(), _createBlock("img", _hoisted_122))
                                                              : _createCommentVNode("", true)
                                      ]),
                                      _createVNode("td", null, _toDisplayString(maneuver.instruction), 1)
                                    ]))
                                  }), 256))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_tab, { class: "import-tab" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_123, [
                  _createVNode("div", null, [
                    _hoisted_124,
                    _createVNode("div", _hoisted_125, [
                      _createVNode(_component_calcite_select, {
                        style: {"margin-top":"15px"},
                        class: "select-export",
                        ref: "roadFileTypeSelect"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_calcite_option, { value: "point" }, {
                            default: _withId(() => [
                              _hoisted_126
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_calcite_option, { value: "polyline" }, {
                            default: _withId(() => [
                              _hoisted_127
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512),
                      _createVNode("div", _hoisted_128, [
                        _createVNode(_component_calcite_button, {
                          ref: "btnGenerateFile",
                          disabled: _ctx.route == null,
                          onClick: _cache[27] || (_cache[27] = $event => (_ctx.generateRoadFile()))
                        }, {
                          default: _withId(() => [
                            _hoisted_129
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createVNode("div", _hoisted_132, [
                      _createVNode(_component_calcite_button, {
                        class: "btn-import",
                        ref: "btnImport",
                        onClick: _cache[28] || (_cache[28] = $event => (_ctx.showModal()))
                      }, {
                        default: _withId(() => [
                          _hoisted_133
                        ]),
                        _: 1
                      }, 512)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_modal, {
              width: "s",
              active: "false",
              "disable-close-button": "",
              "disable-outside-close": "",
              ref: "modal"
            }, {
              default: _withId(() => [
                _hoisted_134,
                _createVNode("div", _hoisted_135, [
                  (!_ctx.showFT && _ctx.allLayers != null)
                    ? (_openBlock(), _createBlock("div", _hoisted_136, [
                        (_ctx.allLayers.findIndex((element) => element.geometryType === 'polyline') != -1)
                          ? (_openBlock(), _createBlock("div", _hoisted_137, [
                              _hoisted_138,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allLayers, (layer) => {
                                return (_openBlock(), _createBlock("div", null, [
                                  (layer.geometryType === 'polyline')
                                    ? (_openBlock(), _createBlock("div", _hoisted_139, [
                                        _createVNode(_component_calcite_button, {
                                          appearance: "transparent",
                                          onClick: $event => {_ctx.showFT = true; _ctx.showFeatureTablePolyline(layer)}
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(layer.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.allLayers.findIndex((element) => element.geometryType === 'point') != -1)
                          ? (_openBlock(), _createBlock("div", _hoisted_140, [
                              _hoisted_141,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allLayers, (layer) => {
                                return (_openBlock(), _createBlock("div", null, [
                                  (layer.geometryType === 'point')
                                    ? (_openBlock(), _createBlock("div", _hoisted_142, [
                                        _createVNode(_component_calcite_button, {
                                          appearance: "transparent",
                                          onClick: $event => {_ctx.showFT = true; _ctx.showFeatureTablePoint(layer)}
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(layer.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    ref: "featureTableRef",
                    class: {'feature-table' : _ctx.showFT}
                  }, null, 2),
                  (_ctx.showFT)
                    ? (_openBlock(), _createBlock("div", _hoisted_143, [
                        _createVNode("div", _hoisted_144, [
                          _hoisted_145,
                          _createVNode("div", _hoisted_146, [
                            _hoisted_147,
                            _createVNode(_component_calcite_switch, {
                              ref: "IgnorWarning",
                              switched: "",
                              scale: "m",
                              style: {"margin-left":"5px","margin-right":"5px"}
                            }, null, 512),
                            _hoisted_148
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.showFT)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 0,
                      slot: "back",
                      color: "light",
                      onClick: _cache[29] || (_cache[29] = $event => {_ctx.showFT = false; _ctx.hideModal(); _ctx.size = 0})
                    }, {
                      default: _withId(() => [
                        _hoisted_149
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showFT)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 1,
                      slot: "back",
                      color: "light",
                      onClick: _cache[30] || (_cache[30] = $event => {_ctx.showFT = false; _ctx.hideFeatureTable()})
                    }, {
                      default: _withId(() => [
                        _hoisted_150
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_calcite_button, {
                  slot: "primary",
                  color: "blue",
                  onClick: _cache[31] || (_cache[31] = $event => {_ctx.showFT = false; _ctx.hideFeatureTable(); _ctx.hideModal(); _ctx.importData(_ctx.layer);}),
                  class: {'clickable' : _ctx.isDisable},
                  disabled: _ctx.canImport == false
                }, {
                  default: _withId(() => [
                    _hoisted_151
                  ]),
                  _: 1
                }, 8, ["class", "disabled"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_calcite_modal, {
              ref: "ShowImportWarning",
              "aria-labelledby": "modal-title",
              color: "blue"
            }, {
              default: _withId(() => [
                _hoisted_152,
                _createVNode("div", _hoisted_153, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ImportWarning, (message) => {
                    return (_openBlock(), _createBlock("div", null, _toDisplayString(message), 1))
                  }), 256))
                ]),
                _createVNode(_component_calcite_button, {
                  slot: "secondary",
                  width: "full",
                  appearance: "outline",
                  onClick: _cache[32] || (_cache[32] = $event => (_ctx.CloseImportWarningModal()))
                }, {
                  default: _withId(() => [
                    _hoisted_154
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 512)
      ])
    ], 2)
  ]))
})